import type { ApolloCache } from "@apollo/client";
import { useMutation } from "@apollo/client";

import { AddPaymentProofDocument, RemovePaymentProofDocument } from "../../__generated__/graphql";

// Drops the cached invoice so the detail (and list badges) refetch with the new proof state.
function evictInvoice(cache: ApolloCache<unknown>, invoiceId?: string) {
  if (invoiceId) cache.evict({ fieldName: "invoiceById", args: { id: invoiceId } });
  cache.evict({ fieldName: "invoicesByFilters" });
  cache.gc();
}

export function usePaymentProof(invoiceId: string) {
  const [addMutation, addState] = useMutation(AddPaymentProofDocument, {
    update: (cache) => evictInvoice(cache, invoiceId),
  });
  const [removeMutation, removeState] = useMutation(RemovePaymentProofDocument, {
    update: (cache) => evictInvoice(cache, invoiceId),
  });

  const addPaymentProof = (file: File) =>
    addMutation({ variables: { input: { invoiceId, file } }, context: { hasUpload: true } });

  const removePaymentProof = () => removeMutation({ variables: { input: { invoiceId } } });

  return {
    addPaymentProof,
    removePaymentProof,
    loading: addState.loading || removeState.loading,
  };
}
